import type { FileItem } from '../file-item';

export type DocType =
  | 'UMID'
  | 'SSS'
  | 'MY_SSS'
  | 'PASSPORT'
  | 'DRIVING_LICENSE'
  | 'PHIL_ID'
  | 'PHIL_SYS_ID'
  | 'DIGITAL_NATIONAL_PHIL_ID'
  | 'E_PHIL_ID'
  | 'PRC'
  | 'SIGNATURE'
  | 'CLIENT_PORTRAIT'
  | 'DEBIT_CARD'
  | 'POSTAL_ID'
  | 'VOTER_ID'
  | 'HEALTH_CARD'
  | 'RECEIPT'
  | 'IMEI'
  | 'SERIAL_NUMBER'
  | 'GCASH_SCORE'
  | 'GCASH_PROFILE';

export enum FileValidationErrorCode {
  UnsupportedImageType = 'UNSUPPORTED_IMAGE_TYPE',
  TooLargeImageSize = 'TOO_LARGE_IMAGE_SIZE',
  RequestEntityTooLarge = 'REQUEST_ENTITY_TOO_LARGE',
  LimitsResolution = 'IMAGE_RESOLUTION_OUT_OF_LIMITS',
}

export type FileUploadPayload = {
  applicationId?: string;
  fileItem: FileItem;
};

export type FileUploadResponse = {
  transactionId: string;
};

export type CheckImageResponse = {
  status: 'ERROR' | 'SUCCESS' | 'PENDING';
  message: string;
};

export class PendingError extends Error {
  name = 'PENDING_ERROR';
}

export function isPendingError(error: Error): error is PendingError {
  return error.name === 'PENDING_ERROR';
}
